import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import PlacementTestListScene from './PlacementTestListScene';
import PlacementTestRulerListService from '../../placement-test-ruler/services/PlacementTestRulerListService';

class PlacementTestListSceneContainer extends Component {
  componentDidMount() {
    PlacementTestRulerListService.init();
  }

  render() {
    return <PlacementTestListScene rulers={toJS(PlacementTestRulerListService.rulers)} />;
  }
}

export default observer(PlacementTestListSceneContainer);
